import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { isCollection, Set } from 'immutable';
function requiredValidator(key) {
  return queryParams => {
    const value = queryParams.get(key);
    if (!value || isCollection(value) && !value.size) {
      return Set(["A value for '".concat(key, "' is required.")]);
    }
    return Set();
  };
}
function oneOfValidatorHelper(value, key, inSet, state) {
  const valueSet = typeof inSet === 'function' ? inSet(state) : inSet;
  if (!valueSet.includes(value)) {
    return Set(["Value '".concat(value, "' is invalid for parameter '").concat(key, "'. Acceptable values are ").concat(valueSet.map(k => "'".concat(k, "'")).join(', '), ".")]);
  }
  return Set();
}
function oneOfValidator(key, inSet, multipleAllowed) {
  return (queryParams, state) => {
    const value = queryParams.get(key);
    if (!value) {
      return Set();
    } else if (isCollection(value)) {
      const valueSet = value;
      if (!multipleAllowed && valueSet.size >= 2) {
        return Set(["Multiple values for '".concat(key, "' are not allowed.")]);
      }
      return valueSet.reduce((acc, v) => acc.union(oneOfValidatorHelper(v, key, inSet, state)), Set());
    } else {
      return oneOfValidatorHelper(value, key, inSet, state);
    }
  };
}
export default class QueryValidator {
  constructor(validators) {
    _defineProperty(this, "validatorSet", void 0);
    if (isCollection(validators)) {
      this.validatorSet = validators;
    } else if (typeof validators === 'function') {
      this.validatorSet = Set([validators]);
    } else {
      this.validatorSet = Set();
    }
  }
  addValidator(validator) {
    return new QueryValidator(this.validatorSet.union(validator instanceof Set ? validator : Set([validator]) // Must be a function
    ));
  }
  addRequiredValidator() {
    for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
      keys[_key] = arguments[_key];
    }
    return new QueryValidator(keys.reduce((res, key) => {
      return res.add(requiredValidator(key));
    }, this.validatorSet));
  }
  addOneOfValidator(key, inSet) {
    let multipleAllowed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return this.addValidator(oneOfValidator(key, inSet, multipleAllowed));
  }
  validate(queryParams, state) {
    return this.validatorSet.reduce((res, validator) => {
      return res.union(validator(queryParams, state));
    }, Set());
  }
}